import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Table } from "@/components/elements/Table";
import { TLanguageTestLevelForm, TLanguageTestForm } from "@/features/master-data/types/masterDataLanguageTestForm";
import { useFormTable } from "@/hooks/useFormTable";
import { Box, styled } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useFormContext } from "react-hook-form";

export const CreateLanguageTestFormTable = () => {
  const { control } = useFormContext<TLanguageTestForm>();

  const formColumns: MRT_ColumnDef<TLanguageTestLevelForm>[] = [
    {
      header: "レベル",
      Cell: ({ row }) => {
        return (
          <FormField control={control} name={`levels.${row.index}.level`}>
            <Input />
          </FormField>
        );
      },
    },
  ];

  const { table } = useFormTable({
    columns: formColumns,
    control,
    name: "levels",
    initFieldData: {
      level: "",
    },
    primaryKey: "id",
  });

  return (
    <TableWrapper>
      <Table table={table} maxHeight={400} />
    </TableWrapper>
  );
};

const TableWrapper = styled(Box)`
  .MuiTableHead-root {
    th {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;
